import { getSearchValue } from '../utils/http';
import { isDevMode } from '../utils/user';
import { SMALL } from '../utils';
import { isUnlimitedPaidASR } from '../utils/status';
import UserTypes from '../action-types/user';
import BoostTypes from '../action-types/boost';
let needInternalAudioAccess = false;
let microphoneAccess = 'granted';
if (window.isElectron) {
    // We ask electron to check the mac internal audio config
    const audioSetup = window.electronIPC.sendSyncCheckAudioSetup();
    if (audioSetup) {
        needInternalAudioAccess = !audioSetup.internalAudio;
        microphoneAccess = audioSetup.micAccess;
    }
}
const initialState = {
    loading: false,
    electronAppLoaded: false,
    inConferenceCall: false,
    currentPlatform: 'web',
    features: {},
    subscription: {},
    avaId: '',
    socketConnectionStatus: 'PENDING',
    roomId: undefined,
    error: {
        name: '',
        message: '',
    },
    readonly: getSearchValue(window, 'readonly', 'false') !== 'false',
    branch: {},
    branchId: localStorage.getItem('ava_branch_id') || '',
    lightView: window.location.href.includes('fii.ava.me/session-'),
    sidebar: false,
    backendSupport: [],
    wsUrl: '',
    intercomDisplayed: window.innerWidth > 800 || microphoneAccess !== 'granted' || needInternalAudioAccess,
    intercomOpen: false,
    displayable: {
        scribeDashboard: false,
        dev: window.location.hostname === 'localhost',
        audio: true,
    },
    userNameFromUrl: getSearchValue(window, 'guestUserName', undefined),
    backends: {
        production: {
            url: 'https://backend.ava.me',
        },
        stage: {
            url: 'https://api-stage.ava.me',
        },
        local: {
            url: 'http://localhost:3000',
        },
    },
    asyncBackends: 'none',
    authenticating: true,
    loggingOut: false,
    needInternalAudioAccess,
    microphoneAccess,
    showQuickSetup: false,
    selectedCaptions: 'free',
    audioParamsSent: false,
    updateUserNameLoading: false,
    updateUserNameSuccess: false,
    updateUserFeaturesLoading: false,
    updateUserHearingProfileLoading: false,
    boostWords: [],
    addBoostWordsLoading: false,
    addBoostWordsSuccess: false,
    shouldShowReconnectingBanner: false,
    websocketStatus: {
        type: 'online',
        background: '#34C54F',
        color: '#fff',
        translation: 'network.nowConnected',
    },
};
const updateIntercomDisplay = (state) => (Object.assign(Object.assign({}, state), { intercomDisplayed: !state.features.scribe &&
        (!SMALL || state.microphoneAccess !== 'granted' || state.needInternalAudioAccess) &&
        !state.isInConversation }));
const updateDisplayable = (state) => {
    const newDev = state.displayable.dev || isDevMode(state.currentPlatform, state.features, state.backends);
    const newScribeDashboard = state.features.scribe && state.currentPlatform === 'web';
    if (newDev === state.displayable.dev && newScribeDashboard === state.displayable.scribeDashboard) {
        return state;
    }
    return Object.assign(Object.assign({}, state), { displayable: Object.assign(Object.assign({}, state.displayable), { dev: newDev, scribeDashboard: newScribeDashboard }) });
};
localStorage.removeItem('ava_branch_id');
export default function scribeConversation(state = initialState, action) {
    var _a, _b;
    switch (action.type) {
        case 'FETCH_BACKEND_SUPPORT': {
            const { support } = action;
            return updateDisplayable(Object.assign(Object.assign({}, state), { backendSupport: [...new Set(state.backendSupport.concat(support || []))] }));
        }
        case 'FETCH_SCRIBE_SESSION_ERROR': {
            return Object.assign(Object.assign({}, state), { error: action.error });
        }
        case 'LOADING_APP': {
            return Object.assign(Object.assign({}, state), { loading: action.status });
        }
        case 'FETCH_SCRIBE_SESSION_SUCCESS': {
            const { url, support, captioner } = action;
            return Object.assign(Object.assign({}, state), { url,
                captioner, socketConnectionStatus: 'PENDING', error: {
                    name: '',
                    message: '',
                }, support: state.backendSupport.concat(support || []) });
        }
        case 'UPDATE_IS_IN_CONVERSATION':
            return updateIntercomDisplay(Object.assign(Object.assign({}, state), { 
                // $FlowFixMe
                isInConversation: action.value }));
        case 'LOST_WEB_SESSION_CONNECTION': {
            return Object.assign(Object.assign({}, state), { socketConnectionStatus: 'DISCONNECTED' });
        }
        case 'SET_INTERCOM_OPEN': {
            return Object.assign(Object.assign({}, state), { intercomOpen: action.open });
        }
        case 'CLOSE_SCRIBE_SESSION_WINDOW': {
            return Object.assign(Object.assign({}, state), { url: '', socketConnectionStatus: 'CLOSED' });
        }
        case 'CLEAR_SCRIBE_SESSION': {
            return initialState;
        }
        case 'FETCH_AVA_USER_SUCCESS': {
            return updateDisplayable(updateIntercomDisplay(Object.assign(Object.assign({}, state), { avaUser: action.user, features: ((_a = action.user) === null || _a === void 0 ? void 0 : _a.features) || [], subscription: ((_b = action.user) === null || _b === void 0 ? void 0 : _b.subscription) || {} })));
        }
        case 'TOGGLE_DEV_MODE': {
            return Object.assign(Object.assign({}, state), { displayable: Object.assign(Object.assign({}, state.displayable), { dev: !state.displayable.dev }) });
        }
        case 'CONNECTION_SUCCEEDED': {
            return Object.assign(Object.assign({}, state), { socketConnectionStatus: 'CONNECTED' });
        }
        case 'TOGGLE_AUDIO_MODE': {
            return Object.assign(Object.assign({}, state), { displayable: Object.assign(Object.assign({}, state.displayable), { audio: !state.displayable.audio }) });
        }
        case 'ENABLE_AUDIO_MODE': {
            return Object.assign(Object.assign({}, state), { displayable: Object.assign(Object.assign({}, state.displayable), { audio: true }) });
        }
        case 'FETCH_AVA_SESSION_SUCCESS': {
            const { url, captioner, avaId, roomId, support } = action;
            return updateDisplayable(Object.assign(Object.assign({}, state), { socketConnectionStatus: 'CONNECTED', url,
                avaId, captioner: Object.assign(Object.assign(Object.assign({}, captioner), (captioner.profile && { profile: captioner.profile })), { 
                    // $FlowFixMe
                    id: captioner.firebaseAuthUID || action.captioner.id }), roomId, backendSupport: [...new Set(state.backendSupport.concat(support || []))] }));
        }
        case 'FETCH_AVA_PROFILE_METRICS': {
            const { metrics } = action;
            return updateDisplayable(Object.assign(Object.assign({}, state), { captioner: Object.assign(Object.assign({}, state.captioner), { profile: Object.assign(Object.assign({}, (state.captioner && state.captioner.profile)), { feedbackMetrics: metrics }) }) }));
        }
        case 'CREATE_NEW_CONVERSATION': {
            return Object.assign(Object.assign({}, state), { loading: true, 
                // $FlowFixMe
                inConferenceCall: action.inConferenceCall });
        }
        case 'FETCH_AVA_SESSION_ERROR': {
            return Object.assign(Object.assign({}, state), { error: action.error });
        }
        case 'TOGGLE_SIDE_BAR': {
            if (state.sidebar === action.value) {
                return state;
            }
            return Object.assign(Object.assign({}, state), { sidebar: !state.sidebar });
        }
        case 'GET_BRANCH_IO_DATA': {
            return Object.assign(Object.assign({}, state), { 
                // $FlowFixMe
                branch: action.content });
        }
        case 'USER_UPDATE': {
            return Object.assign(Object.assign({}, state), { captioner: Object.assign(Object.assign({}, state.captioner), action.user) });
        }
        case 'ROOM_STATUS_UPDATE': {
            return Object.assign({}, state);
        }
        case 'ASYNC_BACKEND_ENDPOINT': {
            return Object.assign(Object.assign({}, state), { 
                // $FlowFixMe
                asyncBackends: action.status, backends: Object.assign(Object.assign({}, state.backends), (action.endpoints
                    ? // $FlowFixMe
                        action.endpoints.reduce((p, c) => (Object.assign(Object.assign({}, p), { [c.url]: c })), {})
                    : {})) });
        }
        case 'SET_AUTHENTICATING': {
            return Object.assign(Object.assign({}, state), { 
                // $FlowFixMe
                authenticating: action.value });
        }
        case 'MAC_AUDIO_SETUP': {
            return Object.assign(Object.assign({}, state), { microphoneAccess: 'granted', needInternalAudioAccess: false, showQuickSetup: false });
        }
        case 'SET_URL_TO_OPEN_WITH_CONVO': {
            return Object.assign(Object.assign({}, state), { 
                // $FlowFixMe
                urlToOpenAfterStartingConvo: action.url });
        }
        case 'REDIRECT_TO': {
            return Object.assign(Object.assign({}, state), { 
                // $FlowFixMe
                redirectTo: action.to });
        }
        case 'CLEAR_REDIRECT': {
            return Object.assign(Object.assign({}, state), { redirectTo: undefined });
        }
        case 'LOGGING_OUT': {
            return Object.assign(Object.assign({}, state), { loggingOut: true });
        }
        case 'SET_SHOW_QUICK_SETUP': {
            return Object.assign(Object.assign({}, state), { 
                // $FlowFixMe
                showQuickSetup: action.show });
        }
        case 'SET_SELECTED_CAPTIONS': {
            return Object.assign(Object.assign({}, state), { 
                // $FlowFixMe
                selectedCaptions: action.value });
        }
        case 'RESET_SELECTED_CAPTIONS': {
            const { captioner: user, subscription } = state;
            const asrTime = Math.floor(action.paidASRCreditTime / 1000);
            const unlimitedPaidASR = isUnlimitedPaidASR(user, subscription);
            const canSelectPremium = unlimitedPaidASR || asrTime > 0;
            return Object.assign(Object.assign({}, state), { selectedCaptions: canSelectPremium ? 'premium' : 'free' });
        }
        case 'V1_WS_URL': {
            return Object.assign(Object.assign({}, state), { wsUrl: action.wsUrl || '' });
        }
        case 'SET_AUDIO_PARAMS_SENT': {
            return Object.assign(Object.assign({}, state), { 
                // $FlowFixMe
                audioParamsSent: action.value });
        }
        case 'ELECTRON_APP_LOADED': {
            return Object.assign(Object.assign({}, state), { 
                // $FlowFixMe
                electronAppLoaded: action.value });
        }
        case 'SET_SHOULD_SHOW_RECONNECTING_BANNER': {
            return Object.assign(Object.assign({}, state), { shouldShowReconnectingBanner: action.payload });
        }
        case 'SET_WEBSOCKET_STATUS': {
            return Object.assign(Object.assign({}, state), { websocketStatus: action.payload });
        }
        case UserTypes.UPDATE_USER_FEATURES_REQUEST:
            return Object.assign(Object.assign({}, state), { updateUserFeaturesLoading: true });
        case UserTypes.UPDATE_USER_FEATURES_SUCCESS:
            return Object.assign(Object.assign({}, state), { captioner: Object.assign(Object.assign({}, state.captioner), { features: Object.assign(Object.assign({}, state.captioner.features), action.payload) }), updateUserFeaturesLoading: false });
        case UserTypes.UPDATE_USER_FEATURES_FAILURE:
            return Object.assign(Object.assign({}, state), { updateUserFeaturesLoading: false });
        case UserTypes.UPDATE_USER_HEARING_PROFILE_REQUEST:
            return Object.assign(Object.assign({}, state), { updateUserHearingProfileLoading: true });
        case UserTypes.UPDATE_USER_HEARING_PROFILE_SUCCESS:
            return Object.assign(Object.assign({}, state), { captioner: Object.assign(Object.assign({}, state.captioner), { profile: Object.assign(Object.assign({}, state.captioner.profile), { hearingProfile: action.payload }) }), updateUserHearingProfileLoading: false });
        case UserTypes.UPDATE_USER_HEARING_PROFILE_FAILURE:
            return Object.assign(Object.assign({}, state), { updateUserHearingProfileLoading: false });
        case UserTypes.UPDATE_USER_NAME_REQUEST:
            return Object.assign(Object.assign({}, state), { updateUserNameLoading: true, updateUserNameSuccess: false });
        case UserTypes.UPDATE_USER_NAME_SUCCESS:
            return Object.assign(Object.assign({}, state), { captioner: Object.assign(Object.assign({}, state.captioner), { userName: action.payload }), updateUserNameLoading: false, updateUserNameSuccess: true });
        case UserTypes.UPDATE_USER_NAME_FAILURE:
            return Object.assign(Object.assign({}, state), { updateUserNameLoading: false });
        case UserTypes.SET_UPDATE_USER_NAME_SUCCESS:
            return Object.assign(Object.assign({}, state), { updateUserNameSuccess: action.payload });
        case UserTypes.SET_ORGANIZATION:
            return Object.assign(Object.assign({}, state), { captioner: Object.assign(Object.assign({}, state.captioner), { organization: action.payload }) });
        case BoostTypes.ADD_BOOST_WORDS_REQUEST:
            return Object.assign(Object.assign({}, state), { addBoostWordsLoading: true });
        case BoostTypes.SET_ADD_BOOST_WORDS_SUCCESS:
            return Object.assign(Object.assign({}, state), { addBoostWordsSuccess: action.payload });
        case BoostTypes.SET_ADD_BOOST_WORDS_LOADING:
            return Object.assign(Object.assign({}, state), { addBoostWordsLoading: action.payload });
        case BoostTypes.SET_BOOST_WORDS:
            let newState = {};
            if (state.addBoostWordsLoading) {
                newState = {
                    addBoostWordsLoading: false,
                    addBoostWordsSuccess: true,
                };
            }
            // $FlowFixMe
            const words = action.payload ? action.payload.split(',').map((w) => w.trim()) : [];
            return Object.assign(Object.assign(Object.assign({}, state), newState), { boostWords: words });
        default: // eslint-disable-line no-unused-expressions
            // $FlowFixMe
            action;
            return state;
    }
}
